var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlackColorized = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8.417,
  width: 3.374,
  height: 7.583,
  rx: 1.687,
  fill: "#4DAA78"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 8.417,
  y: 8.417,
  width: 7.583,
  height: 3.374,
  rx: 1.687,
  fill: "#E5B145"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 4.209,
  width: 7.583,
  height: 3.374,
  rx: 1.687,
  fill: "#60AFDA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.209 1.687a1.687 1.687 0 0 1 3.374 0v1.687H5.896a1.687 1.687 0 0 1-1.687-1.687z",
  fill: "#60AFDA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.626 5.896a1.687 1.687 0 1 1 1.687 1.687h-1.687V5.896z",
  fill: "#4DAA78"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10.104c0-.931.755-1.687 1.687-1.687h1.687v1.687a1.687 1.687 0 1 1-3.374 0z",
  fill: "#C1316A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.417 12.626h1.687a1.687 1.687 0 1 1-1.687 1.687v-1.687z",
  fill: "#E5B145"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 4.209,
  y: 8.417,
  width: 3.374,
  height: 7.583,
  rx: 1.687,
  fill: "#C1316A"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlackColorized);
export default ForwardRef;